module.exports = __webpack_public_path__ + "img/icon_sie_replacement.55f17bf3.svg";